<div class='text-center' style='margin-top:20px;'>
    <i class="fa fa-cog fa-spin fa-7x fa-fw"></i>
    <span class="sr-only">Loading...</span>
    <div class="alert alert-success text-center" role="alert"> <strong>Signing In!</strong> Please sit tight while we gather your information... </div>
</div>
